import { api } from '@/lib/api';
import type { CaseContent } from '@fame/shared';
import { useQuery } from '@tanstack/react-query';

export interface CaseItem {
  id: string;
  category: 'incentive' | 'event' | 'luxury';
  slug: string;
  title: { nl?: string; fr?: string; en?: string };
  status: 'draft' | 'in_review' | 'changes_requested' | 'published';
  isFeatured: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CaseDetail extends CaseItem {
  content?: CaseContent | { nl?: Record<string, unknown> };
  tagline?: { nl?: string; fr?: string; en?: string };
  subtitle?: { nl?: string; fr?: string; en?: string };
  location?: { nl?: string; fr?: string; en?: string };
  attendees?: { nl?: string; fr?: string; en?: string };
  company?: { nl?: string; fr?: string; en?: string };
  duration?: { nl?: string; fr?: string; en?: string };
  seoDescription?: { nl?: string; fr?: string; en?: string };
  reviewNotes?: string;
  sortOrder: number;
  media: Array<{
    id: string;
    mediaAssetId: string;
    role: 'hero' | 'gallery' | 'content';
    sortOrder: number;
    cropX: number;
  }>;
}

export interface MediaAsset {
  id: string;
  originalFilename: string;
  mimeType: string;
  sizeBytes: number;
  createdAt: string;
}

export function useCases() {
  return useQuery({
    queryKey: ['cases'],
    queryFn: () => api.get<CaseItem[]>('/cases'),
    refetchOnMount: 'always',
  });
}

export function useCase(id: string) {
  return useQuery({
    queryKey: ['cases', id],
    queryFn: () => api.get<CaseDetail>(`/cases/${id}`),
    enabled: Boolean(id),
  });
}
